import { Badge, Card, CircularProgress, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid, IconButton, Stack, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from "react-redux";
import MDButton from "components/MDButton";
import { useRef, useState } from "react";
import MDInput from "components/MDInput";
import { uploadImage } from "../../redux/slices/common";
import defaultImage from 'assets/images/placeholder-image.png';
import { useDispatch } from "react-redux";

const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '160px',
    height: '160px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
};
const badgeCircularProgressIcon = {
    backgroundColor: '#fff',
    borderRadius: 10,
    p: .5,
    mr: 14,
    mt: 14
};
export default function SocialMediaUpload({ closeModal }) {
    const dispatch = useDispatch()
    const { modalData } = useSelector(state => state.modal);
    const { SocialMediaHandler = () => { }, socialMedia } = modalData

    const [formData, setFormData] = useState({
        "platform": "",
        "link": "",
        'status': true,
    })
    const uploadedImageRef = useRef();

    const { isUploading = false } = useSelector((state => state.common));

    const [errors, setErrors] = useState({})

    const mediaChangeHandler = (event) => {
        setErrors({
            "platform": "",
            "link": "",
            "imageUrl": ""
        })
        setFormData((prevState) => ({
            ...prevState,  // Spread the previous state
            [event?.target?.name]: event?.target?.value  // Update the specific field
        }));
    }
    // const isValidURL = (url) => {
    //     const urlPattern = new RegExp(
    //         /^(https?:\/\/)([\w.-]+)\.([a-z]{2,6})([/\w .-]*)*\/?$/i
    //     );
    //     return urlPattern.test(url);
    // };

    const isValidURL = (url) => {
        const urlPattern = new RegExp(
          '^(https?:\\/\\/)?' +                    // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})' + // domain name
          '(\\:\\d+)?' +                           // port
          '(\\/[-a-z\\d%@_.~+&:]*)*' +             // path
          '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' +         // query string
          '(\\#[-a-z\\d_]*)?$',                    // fragment
          'i'
        );
        return !!urlPattern.test(url);
      };



    const validateReasons = () => {
        let isError = false
        let errors = {}
        if (!formData?.platform?.trim()) {
            isError = true
            errors = { ...errors, platform: 'Platform  is required' }
        }
        if (!formData?.link?.trim()) {
            isError = true;
            errors = { ...errors, link: "Link is required" };
        } else if (!isValidURL(formData.link)) {
            isError = true;
            errors = { ...errors, link: "Invalid link: must start with http:// or https://" };
        }
        if (!formData.image || !formData?.image?.url?.trim()) {
            isError = true
            errors = { ...errors, imageUrl: 'Image  is required' }
        }
        return { errors, isError }
    }

    const submitHandler = () => {
        const { isError, errors } = validateReasons()
        setErrors(errors)
        if (isError) return;
        setErrors({})
        SocialMediaHandler(formData, socialMedia)

        closeModal()
    }

    const productImageUploadHandler = async (e, imageType) => {
        if (isUploading) return;
        uploadedImageRef.current = imageType;
        if (e.target.files.length) {
            const file = e.target.files[0];
            const body = new FormData();
            body.append('filePath', file);
            dispatch(uploadImage(body)).unwrap().then((res => {
                setFormData((prev) => ({
                    ...prev,
                    image: {
                        ...prev.image, // Keep existing image properties
                        url: res.fileUrl, // Update only the URL
                    },
                }));
            }));
        }
    };

    return (
        <Card sx={{ p: 4, borderRadius: 0 }}>
            <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 4 }} display='flex' alignItems='center' justifyContent='space-between'>
                Social Media Upload
                <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
                <Grid container alignItems='center' spacing={{ xs: 3, md: 3 }}>
                    <Grid item xs={12}>
                        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} mb={2}>
                            <Badge
                                overlap='circular'
                                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                badgeContent={
                                    isUploading ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                                }
                            >
                                <img key={formData?.image?.url} style={uploadThumbnailImage} src={formData?.image?.url || defaultImage} alt='documentId' />
                            </Badge>
                            <label htmlFor='imageUrl-input'>
                                <MDButton
                                    type='button'
                                    variant='outlined'
                                    color='secondary'
                                    component='span'
                                    disabled={isUploading}
                                >
                                    {formData?.image?.url ? 'Change Image' : 'Add Image'}
                                </MDButton>
                            </label>
                            <MDInput
                                id='imageUrl-input'
                                type='file'
                                name='imageUrl'
                                onChange={(e) => productImageUploadHandler(e, 'imageUrl')}
                                fullWidth
                                disabled={isUploading}
                                style={{ display: 'none' }}
                            />
                            {Boolean(errors?.imageUrl) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.imageUrl}</FormHelperText>}
                        </Stack>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            autoComplete='off'
                            fullWidth
                            helperText={errors?.platform}
                            error={errors?.platform}
                            label={'Platform'}
                            name='platform'
                            onChange={(e) => mediaChangeHandler(e)}
                            className='form-input'
                            value={formData?.platform || ''}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            autoComplete='off'
                            fullWidth
                            helperText={errors?.link}
                            error={errors?.link}
                            label={'Link'}
                            name='link'
                            onChange={(e) => mediaChangeHandler(e)}
                            className='form-input'
                            value={formData?.link || ''}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 0, mt: 4 }}>
                <MDButton sx={{ minWidth: '160px' }} type='button' variant='outlined' color='dark' className='dark-outlined-btn' onClick={() => closeModal()}>
                    Cancel
                </MDButton>
                <MDButton sx={{ minWidth: '160px' }} type='button' variant='contained' color='primary' onClick={() => submitHandler()} >
                    Save
                </MDButton>
            </DialogActions>
        </Card>
    )
}